<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds medium h-full dark"
>
  <div
    class="flx-modal-title text-white"
    flxModalHeaderTitle
  >
    {{ action.name }} - Set Source
  </div>

  <div
    class="flx-modal-subtitle text-neutral-400 text-sm"
    flxModalHeaderSubtitle
  >
    Add extra information (from documents or images) about the resource to be generated.
  </div>

  <div class="flx-modal-body">
    <flx-segmented-button
      [ngModel]="selectedTab()"
      (ngModelChange)="selectedTab.set($event)"
      class="header-segmented-button p-1 rounded-lg bg-neutral-900 w-full"
    >
      @for (tab of tabs; track tab.value) {
        <button
          [value]="tab.value"
          [ngClass]="{
            'text-neutral-400': tab.disabled,
            'pointer-events-none': tab.disabled,
          }"
          class="h-6 text-xs rounded [&:not(.selected)]:bg-neutral-900 text-white border-0"
          flxSegmentedOption
        >
          {{ tab.label }}
        </button>
      }
    </flx-segmented-button>

    @if (fileUploadConfig()) {
      <flx-file-source-upload
        [config]="fileUploadConfig()"
        [initialFiles]="selectedTab() === initialFileType && initialFile ? [initialFile] : []"
        (fileSelected)="onFileSelected($event)"
        (uploadError)="onUploadError($event)"
      />
    }
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        flxButton
        type="button"
      >
        Discard
      </button>
      <button
        [disabled]="!hasSelectedSource()"
        (click)="save()"
        class="flx-ds primary"
        flxButton
        type="button"
      >
        Save Source Settings
      </button>
    </div>
  </div>
</flx-modal>
